// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"96f13f6e","128":"96f13f6e","227":"96f13f6e","307":"96f13f6e","475":"96f13f6e","543":"96f13f6e","550":"96f13f6e","814":"96f13f6e"}[chunkId] + ".chunk.css";
};